// src/api/additionalCostApi.ts

import Repository from './Repository';
import {AdditionalCost} from "@/models/AdditionalCost/AdditionalCost";
import {AdditionalCostUpdate} from "@/models/AdditionalCost/AdditionalCostUpdate";
import {AdditionalCostCreate} from "@/models/AdditionalCost/AdditionalCostCreate";
import {ModifyIngredientCostDto} from "@/models/RecipeInvoice/ModifyIngredientCostDto";
import {AxiosResponse} from "axios";

export const resource = '/additionalCost';

export default {
  // Get additional costs for restaurant
  getAdditionalCosts(restaurantId: number): Promise<AxiosResponse<AdditionalCost[]>> {
    return Repository.get(`${resource}/ListAdditionalCostsForRestaurant`, { params: { restaurantId }, withCredentials: true });
  },
  // Get additional cost by ID
  getAdditionalCostById(additionalCostId: number): Promise<AxiosResponse<AdditionalCost>> {
    return Repository.get(`${resource}/GetAdditionalCostById/${additionalCostId}`, { withCredentials: true });
  },
  // Delete multiple additional costs
  deleteAdditionalCosts(additionalCostIds: number[]): Promise<AxiosResponse<void>> {
    return Repository.post(`${resource}/DeleteAdditionalCosts`, additionalCostIds, { withCredentials: true });
  },
  createAdditionalCost(ingredientCosts: any[]) {
    return Repository.post(`${resource}/CreateAdditionalCosts`, { ingredientCosts: ingredientCosts }, { withCredentials: true });
  },
  updateAdditionalCost(ingredientCost: ModifyIngredientCostDto) {
    return Repository.post(`${resource}/UpdateAdditionalCost`, ingredientCost, { withCredentials: true });
  },
};